import script from "./arrivalList.vue?vue&type=script&setup=true&lang=js"
export * from "./arrivalList.vue?vue&type=script&setup=true&lang=js"

import "./arrivalList.vue?vue&type=style&index=0&id=4f07697d&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f07697d"]])

export default __exports__